import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Gift, Copy, Link2, Users, Crown } from "lucide-react";
import { openTrialPoster } from "../lib/trialPoster";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReferralCard({ token }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/referrals/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setData(data)).catch(() => {});
  }, [token]);
  if (!data) return null;

  const link = `${window.location.origin}/redeem?code=${encodeURIComponent(data.code)}`;
  const copy = (val, label) => { navigator.clipboard.writeText(val); toast.success(`${label} copied!`); };

  const stats = [
    { label: "Friends Joined", value: data.referred_count, icon: Users },
    { label: "Enrolled", value: data.subscribed_count, icon: Crown },
    { label: "Free Months", value: data.free_months_earned, icon: Gift },
  ];

  return (
    <div data-testid="referral-card" className="bg-gradient-to-br from-[#161616] to-[#0e0e0e] border border-[#D4AF37]/30 rounded-2xl p-6">
      <div className="flex items-center gap-2 mb-1">
        <Gift size={18} className="text-[#D4AF37]" />
        <h3 className="font-headings text-xl uppercase tracking-wide">Refer a Friend, Earn a Free Month</h3>
      </div>
      <p className="text-sm text-white/50 mb-5">Share your code — your friend gets a free 7-day Elite trial, and you earn a <b className="text-white/80">free month</b> the moment they enroll.</p>

      <div className="flex flex-wrap items-center gap-2 mb-5">
        <code data-testid="referral-code" className="font-mono text-lg font-bold text-[#D4AF37] bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg px-3 py-1.5 tracking-widest">{data.code}</code>
        <button data-testid="referral-copy-code" onClick={() => copy(data.code, "Code")} className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-white/60 hover:text-white border border-white/15 rounded-md px-3 py-2 transition-colors"><Copy size={13} /> Code</button>
        <button data-testid="referral-copy-link" onClick={() => copy(link, "Invite link")} className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-black bg-[#D4AF37] hover:bg-[#e8c65a] rounded-md px-3 py-2 transition-colors"><Link2 size={13} /> Copy Invite Link</button>
        <button data-testid="referral-poster" onClick={() => openTrialPoster({ code: data.code })} className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-white/60 hover:text-white border border-white/15 rounded-md px-3 py-2 transition-colors">QR Poster</button>
      </div>

      <div className="grid grid-cols-3 gap-3">
        {stats.map((s) => (
          <div key={s.label} data-testid={`referral-stat-${s.label.toLowerCase().replace(/ /g, "-")}`} className="bg-[#0d0d0d] border border-white/10 rounded-xl p-3 text-center">
            <s.icon size={15} className="text-[#D4AF37] mx-auto mb-1.5" />
            <div className="font-cover text-2xl leading-none text-white">{s.value}</div>
            <div className="text-[10px] uppercase tracking-widest text-white/40 mt-1.5">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
